export default __webpack_public_path__ + "static/media/art-slt-poster-3.b347b057.jpg";